export default class Mover {
  get [Symbol.toStringTag]() {
    return "Mover";
  }
  n_top = 0;
  n_left = 0;
  n_width = 0;
  n_height = 0;
  constructor() {
  }
  get n_right() {
    return this.n_left + this.n_width;
  }

  get n_bottom() {
    return this.n_top + this.n_height;
  }
}


// WEBPACK FOOTER //
// ./src/components/dynamicRoute1/lv2/continuing/Mover.js